import React from 'react'
import PrivacyPolicy from '../Menpages/privacy-policy/main'
import Header from '../Menhome/Header'
import Bredcom from '../MenTeam/Bredcom'
import Footer from '../Menhome/Footer'


function Privacypolicy() {
  return (
    <>
    <Header/>
    <Bredcom title={"Policies"} head={"Privacy Policy"} sbtitle={"Privacy Policy"}/>
    <PrivacyPolicy/>
    <Footer/>
    </>
  )
}

export default Privacypolicy;